<template>
    <div id="learning-timeline">
        <h1>Learning Timeline</h1>
        <div class="timeline-container">
            <el-timeline>
                <div v-for="(i, index) in items" :key="i.id">
                    <LearningItem :item="i" :index="index" :itemStatus="itemStatus" :switchStatus="switchStatus"/>
                </div>
            </el-timeline>
        </div>

    </div>
</template>

<script>
import LearningItem from './LearningItem.vue'

export default {
    name: 'LearningTimeline',
    components: { LearningItem },
    data() {
        return {
            itemStatus: [],
            items: [
                {
                    id: 'nodejs',
                    name: 'NodeJS',
                    timestamp: '2022/6/27 - 2022/7/6, 2022/7/28 - 2022/8/5',
                    syllabus: [
                        'npm & yarn, CommonJS, Node Modules, Express, MongoDB',
                        'Express, Express Router, Middleware, Express-cli',
                        'MongoDB, CRUD Operations',
                    ],
                    blogLink: 'https://donaldlamnl.github.io/myBlog/categories/NodeJS',
                    codeLink: 'nodejs-code.zip',
                    markDown: 'nodejs.md',
                },
                {
                    id: 'ajax',
                    name: 'AJAX',
                    timestamp: '2022/7/27 - 2022/8/1',
                    syllabus: [
                        'XMLRequestHttp, GET & POST Request, JQuery AJAX',
                        'Same-Origin-Policy, JSONP, CORS',
                        'Anxios, Fetch'
                    ],
                    blogLink: 'https://donaldlamnl.github.io/myBlog/categories/AJAX',
                    codeLink: 'ajax-code.zip',
                    markDown: 'ajax.md',
                },
                {
                    id: 'es6',
                    name: 'JavaScript ES6-11',
                    timestamp: '2022/7/23 - 2022/7/26',
                    syllabus: [
                        'Destructuring Assignment, Template String, Arrow Function',
                        'Symbol, Iterator & Generator, Promise',
                        'Map, Set, Class'
                    ],
                    blogLink: 'https://donaldlamnl.github.io/myBlog/categories/JavaScript',
                    codeLink: 'es6-code.zip',
                    markDown: 'es6.md',
                },
                {
                    id: 'jsa',
                    name: 'JavaScript Advanced',
                    timestamp: '2022/7/9 - 2022/7/22',
                    syllabus: [
                        'Class & Object, Constructor Function, Prototype, Extends',
                        'Functions, Closure, Recursion, Shallow & Deep Copy',
                        'Regular Expression'
                    ],
                    blogLink: 'https://donaldlamnl.github.io/myBlog/categories/JavaScript',
                    codeLink: 'jsa-code.zip',
                    markDown: 'jsa.md',
                },
                {
                    id: 'vuejs',
                    name: 'VueJS',
                    timestamp: '2022/6/5 - 2022/6/26',
                    syllabus: [
                        'Vue 2 Essentials, MVVM, Diff Algorithm, Components, Lifecycle',
                        'Vue-cli, props, Global Event Bus, Publish & Subscribe, Vuex, AJAX',
                        'Vue Router'
                    ],
                    codeLink: 'vuejs-code.zip',
                    markDown: 'vuejs.md',
                },
                {
                    id: 'java',
                    name: 'JavaSE',
                    timestamp: '2020 Summer, 2021 Autumn Semestor',
                    syllabus: [
                        'Java Basic, Function, Array, Recursion',
                        'Object-Oriented Programming, Class & Object, Constructor',
                        'Inheritance, Encapsulation, Polymorphism, Override & Overload'
                    ],
                    codeLink: 'java-code.zip',
                },
                {
                    id: 'c-lang',
                    name: 'C Lang',
                    timestamp: '2020 Autumn Semestor, 2022 Spring Semestor',
                    syllabus: [
                        'File i/o, Pointer, String & Array',
                        'Data Structure: Linked-List, Stack, Queue, Tree, Heap, Hash, Quick Sorting',
                        'Union-Find, Dynammic Programming, Greedy Algorithm, Text Processing'
                    ],
                    codeLink: 'c-lang-code.zip',
                    materials: 'c-lang.zip'
                },
                {
                    id: 'js',
                    name: 'JavaScript',
                    timestamp: '2020 Summer, 2021 Autumn Semestor',
                    syllabus: [
                        'JS Data Types & Keywords, JS APIs',
                        'Class & Object, Scope, Constructor Function, Prototype',
                        'Dom Operations, Event, Event Bubbles, Mouse & Keyboard Event',
                        'BOM, Navigator, History, Interval & Timeout',
                    ],
                    codeLink: 'js-code.zip'
                },
                {
                    id: 'css3',
                    name: 'CSS3',
                    timestamp: '2021/5/13 - 2021/6/1',
                    syllabus: [
                        'Layout, margin & border & padding, border-radius & shadow',
                        'Float, BFC, clearFix, Position (relative, absolute, fixed, sticky)',
                        'Font & Icon, Background, Background Image & gradient, Table Style',
                    ],
                    codeLink: 'css3-code.zip'
                },
                {
                    id: 'html5',
                    name: 'HTML5',
                    timestamp: '2021/5/12',
                    syllabus: [
                        'HTML Tags, Relative path, List, Table, Form'
                    ],
                    codeLink: 'html5-code.zip'
                },
            ]
        }
    },
    methods: {
        switchStatus(index){
            let status = this.itemStatus[index] === '' ? 'collapsed' : ''
            this.itemStatus.forEach((e, i) => {
                if(index === i){
                    this.itemStatus.splice(i, 1, status)
                }else{
                    this.itemStatus.splice(i, 1, 'collapsed')
                }
            })
        }
    },
    mounted() {
        for(let i = 0; i < this.items.length; i++){
            this.itemStatus.push('collapsed')
        }
    },
}
</script>

<style scoped>
h1{
    text-align: center;
    height: 80px;
    font-size: 40px;
    line-height: 80px;
    font-family: "Snell Roundhand", "cursive";
    font-weight: bolder;

}
.timeline-container{
    width: 550px;
    margin: auto;
    padding: 50px;
}
</style>